import { combineReducers } from 'redux';

import fetchDailyMinimumPricingMap, {
    fetchDailyMinimumPricingAction,
} from './actions/fetchDailyMinimumPricing';
import pricingReducerMap, {
    selectors as pricingSelectors,
} from './data/pricing/index';
import namespace from './types';

const reducerMap = {
    ...pricingReducerMap,
    ...fetchDailyMinimumPricingMap,
};

const reducer = combineReducers(reducerMap);

export {
    fetchDailyMinimumPricingAction,
    pricingSelectors,
};

export default {
    [namespace]: reducer,
};
